export function toMachineStageKey(
  stage: string | null | undefined
): string | null {
  if (stage == null) {
    return null
  }

  const normalized = stage
    .trim()
    .toLowerCase()
    .replace(/[\s/-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')

  return normalized.length > 0 ? normalized : null
}
